module finadai.app.admin {
    export var NAME = "finadai.app.admin";
    function ConfigRoutes($stateProvider: ng.ui.IStateProvider){
        $stateProvider.state('app.admin', {
            templateUrl: 'app/admin/admin.tpl.html',
            url: '/admin',
        })
            .state('app.admin.create', {
                templateUrl: 'app/admin/create/create.tpl.html',
                url: '/createNegotiation/',
                controller: 'AdminCreateController',
                resolve: {}
            })
            .state('app.admin.search', {
                templateUrl: 'app/admin/search/search.tpl.html',
                url: '/searchCustomer',
                controller: 'AdminSearchController',
                resolve: {}
            })
            .state('app.admin.find_negotiation', {
                templateUrl: 'app/admin/findNegotiation/findNegotiation.tpl.html',
                url: '/findNegotiation',
                controller: 'AdminFindNegotiationController',
                resolve: {}
            })
            .state('app.admin.cancel_negotiation', {
                templateUrl: 'app/admin/cancel/cancel.tpl.html',
                url: '/cancelNegotiation',
                controller: 'AdminCancelNegotiationController',
                resolve: {}
            })
            .state('app.admin.find', {
                templateUrl: 'app/admin/find/find.tpl.html',
                url: '/findCustomer',
                controller: 'AdminFindController',
                resolve: {}
            })
            .state('app.admin.update', {
                templateUrl: 'app/admin/update/update.tpl.html',
                url: '/updateCustomer',
                controller: 'AdminUpdateCustomerController',
                resolve: {}
            }).state('app.admin.create_reference', {
            templateUrl: 'app/admin/create_reference/create_reference.tpl.html',
            url: '/createReference',
            controller: 'AdminCreateReferenceController',
            resolve: {}
        }).state('app.admin.change_sic', {
            templateUrl: 'app/admin/change_sic/change_sic.tpl.html',
            url: '/changeSIC',
            controller: 'AdminChangeSICController',
            resolve: {}
        });
    }
    export function run(){
        var admin = angular.module(NAME, [
            finadai.app.admin.search.NAME,
            finadai.app.admin.create.NAME,
            finadai.app.admin.cancel_negotiation.NAME,
            finadai.app.admin.update.NAME,
            finadai.app.admin.find.NAME,
            finadai.app.admin.create_reference.NAME,
            finadai.app.admin.find_negotiation.NAME,
            finadai.app.admin.change_sic.NAME
        ]);
        admin.config(ConfigRoutes);
    }
}
finadai.app.admin.run();
